import React from "react";
import { Link, useParams } from "react-router-dom";
import Layouts from "../../config/layouts/Layouts";
import NavbarComponent from "../../components/navbar/Navbar";
import Footer from "../../components/footer/Footer";
import { AVIATION_PAGE, EXPERTISE_PAGES } from "../../data/expertisePages";

function ExpertiseContent({ page }) {
    return (
        <>
            <section className="mx-auto max-w-5xl px-5 pb-16 pt-32 sm:pt-36 md:px-8 md:pt-40">
                <p className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-em-accent">
                    {page.eyebrow}
                </p>
                <h1 className="max-w-4xl text-4xl font-black tracking-tight text-em-text md:text-6xl">
                    {page.title}
                </h1>
                <p className="mt-7 max-w-3xl text-lg leading-8 text-em-soft md:text-xl">
                    {page.lead}
                </p>
                <div className="mt-10 flex flex-wrap gap-3">
                    <Link to="/contacto" className="btn-primary">Hablemos del proyecto</Link>
                    <Link to="/proyectos" className="btn-secondary">Ver evidencia</Link>
                </div>
            </section>

            <section className="border-y border-em-text/10 bg-em-card/40">
                <div className="mx-auto max-w-5xl px-5 py-14 md:px-8">
                    <h2 className="text-2xl font-extrabold text-em-text">Qué hacemos</h2>
                    <p className="mt-4 max-w-4xl text-base leading-7 text-em-soft">
                        {page.definition}
                    </p>
                    <div className="mt-9 grid gap-4 md:grid-cols-2">
                        {page.capabilities.map(([title, body]) => (
                            <article key={title} className="rounded-2xl border border-em-text/10 bg-em-bg p-6">
                                <h3 className="text-lg font-bold text-em-text">{title}</h3>
                                <p className="mt-2 leading-7 text-em-soft">{body}</p>
                            </article>
                        ))}
                    </div>
                </div>
            </section>

            <section className="mx-auto grid max-w-5xl gap-12 px-5 py-16 md:grid-cols-[0.8fr_1.2fr] md:px-8">
                <div>
                    <p className="text-xs font-bold uppercase tracking-[0.2em] text-em-accent2">Método</p>
                    <h2 className="mt-3 text-3xl font-black text-em-text">Cómo abordamos el trabajo</h2>
                </div>
                <ol className="space-y-4">
                    {page.process.map((step, index) => (
                        <li key={step} className="flex gap-4 rounded-2xl border border-em-text/10 bg-em-card p-5">
                            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-em-accent/15 text-sm font-black text-em-accent">
                                {index + 1}
                            </span>
                            <p className="pt-1 leading-7 text-em-soft">{step}</p>
                        </li>
                    ))}
                </ol>
            </section>

            <section className="mx-auto max-w-5xl px-5 pb-[calc(7rem+var(--em-footer-h))] md:px-8">
                {page.authorityLinks ? (
                    <div className="mb-16">
                        <p className="text-xs font-bold uppercase tracking-[0.2em] text-em-accent2">Centro de conocimiento</p>
                        <h2 className="mt-3 text-3xl font-black text-em-text">Profundiza por problema operacional</h2>
                        <div className="mt-8 grid gap-4 sm:grid-cols-2">
                            {page.authorityLinks.map(([label, to]) => (
                                <Link key={to} to={to} className="rounded-2xl border border-em-text/10 bg-em-card p-5 font-bold text-em-text transition hover:-translate-y-1 hover:border-em-accent/40 hover:text-em-accent">
                                    {label} <span aria-hidden>→</span>
                                </Link>
                            ))}
                        </div>
                        <h3 className="mt-10 text-xl font-extrabold text-em-text">Fuentes marco</h3>
                        <ul className="mt-4 space-y-2">
                            {page.sources.map(([label, url]) => (
                                <li key={url}><a className="text-em-accent hover:text-em-accent2" href={url} target="_blank" rel="noopener noreferrer">{label} ↗</a></li>
                            ))}
                        </ul>
                    </div>
                ) : null}
                <p className="text-xs font-bold uppercase tracking-[0.2em] text-em-accent2">Preguntas frecuentes</p>
                <h2 className="mt-3 text-3xl font-black text-em-text">Respuestas directas</h2>
                <div className="mt-8 divide-y divide-em-text/10 border-y border-em-text/10">
                    {page.faq.map(([question, answer]) => (
                        <article key={question} className="py-6">
                            <h3 className="text-lg font-bold text-em-text">{question}</h3>
                            <p className="mt-2 max-w-4xl leading-7 text-em-soft">{answer}</p>
                        </article>
                    ))}
                </div>
            </section>
        </>
    );
}

export function AviationPage() {
    return (
        <Layouts>
            <header><NavbarComponent /></header>
            <main className="min-h-screen bg-em-bg text-em-text"><ExpertiseContent page={AVIATION_PAGE} /></main>
            <Footer />
        </Layouts>
    );
}

export default function ExpertisePage({ service: serviceProp }) {
    const { service: serviceParam } = useParams();
    const page = EXPERTISE_PAGES[serviceProp || serviceParam];
    return (
        <Layouts>
            <header><NavbarComponent /></header>
            <main className="min-h-screen bg-em-bg text-em-text"><ExpertiseContent page={page} /></main>
            <Footer />
        </Layouts>
    );
}
